import styled from "styled-components";
import Theme from "../../../../Styles/Themes";
import config from "../../../../Config/config.json"

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    transition: 1s ease;
`;

export const SideBarButton = styled.a`
    position:  relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    color: #fff;
    background: transparent;
    border: none;
    outline: none;
    font-weight: ${(props) => ( props.$isSelected ? '700' : '400')};
    font-size: ${Theme[config.theme].font.labels['small'].size};
    line-height: ${Theme[config.theme].font.labels['small'].line_height};
    cursor: pointer;
    padding: 5px;
    width: 100%;
    white-space: nowrap;
    text-decoration: none;
    opacity: ${(props) => (props.$isDisabled ? 0.5 : 1)};
    &:hover {
        color: ${(props) => props.$isSelected || props.$isDisabled ? '#fff' : props.$isActive ? '#3E78AA' : '#fff'};}
    @media (min-width: 1281px) {
        font-size: ${Theme[config.theme].font.labels['small'].size};
        line-height: ${Theme[config.theme].font.labels['small'].line_height};
    }
`;


export const Circle = styled.div`
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    left: -15px;
    background: ${(props) => ( props.$isSelected ? '#3E78AA' : props.$isHovered ?  props.$isDisabled ? '#BCBCBC' : props.$isActive ? '#3E78AA' : '#fff' : '#BCBCBC')};
    border-radius: 9999px;
    z-index: 5;
`;

export const Line = styled.div`
    position: absolute;
    top: 23px;
    width: 30px; 
    height: 0px; 
    transform: rotate(270deg); 
    transform-origin: -5px 11px; 
    background: #BCBCBC;
    border: 1.50px #BCBCBC solid; 
    z-index: 1;
`;